<div class="container py-5 ">
  <div class="main-title">
    <h1>Reports</h1>
  </div>
  <div class="main_table">
    <div class="ctm-title">
      <h2>Resort Summary</h2>
    </div>
    <div class="ctm-table resort" style="overflow-x: auto;">
      <p-table [value]="products" >
        <ng-template pTemplate="header">
            <tr>
                <th></th>
                <th>OUTs</th>
                <th>INs</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-product>
            <tr>
                <td>{{product.name}}</td>
                <td>{{product.outs}}</td>
                <td>{{product.ins}}</td>
            </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

  <div class="table_extra_content mt-5">
    <h3>Interim Cleanings Today: NONE</h3>

      <h3>Linen Service Today: NONE</h3>
  </div>

  <div class="main_table">
  <div class="ctm-table mt-5 beds" style="overflow-x: auto;">
    <div class="ctm-title">
      <h2>Roll-Away Bed Locations</h2>
    </div>
    <table style="width: 100%;">
      <tbody>
      <tr>
        <td>HKH-247</td>
        <td>HKK-140*(DO)</td>
        <td>HKL-5B*(DO)  </td>
      </tr>
      </tbody>
    </table>
  </div> 
  </div>
  <div class="main_table desktop">
  <div class="ctm-table mt-3 units" style="overflow-x: auto;">
    <div class="ctm-title">
      <h2>Open Units Today:</h2>
    </div>
    <table style="width: 100%;">
      <tbody>
      <tr>
        <td>HKH-229(7) </td>
        <td>HKH-406(26)</td>
        <td>KRO-Q102(21)</td>
        <td>HKK-201(38)</td>
        <td>PKH-205(11)</td>
      </tr>
      <tr>
        <td>KBV-30G2(155)</td>
        <td>HKH-203(23)</td>
        <td>MAH-611(123)</td>
        <td> HKH-225(90)</td>
        <td>KGV-16P3(6)</td>
      </tr>
      <tr>
        <td>NAP-C18(2)</td>
        <td>HKH-204(13) </td>
        <td>HKK-1029(43)</td>
        <td>MAH-1211(90)</td>
        <td>HKH-529(189)</td>
      </tr>
      <tr>
        <td>KGV-24P7(55)</td>
        <td>HKK-513(2)</td>
        <td>KBV-15B3(168)</td>
        <td>HKH-504(31)</td>
        <td>HKK-343(2)</td>
      </tr>
      <tr>
        <td>HKK-439(20)</td>
        <td>MAH-419(133)</td>
        <td>KBV-28G2(3)</td>
        <td>HKK-242(0)</td>
        <td>KGV-19T1(140)</td>
      </tr>
      <tr>
        <td>NAP-B39(6) </td>
        <td>KBV-37B3(9)</td>
        <td>KGV-19P2(3)</td>
        <td>KGV-24P2(3)</td>
        <td>HKK-332(0)</td>
      </tr>
      <tr>
        <td>HKL-12A(5) </td>
        <td>HKL-12B(3)</td>
        <td> NAP-C43(17) </td>
        <td>TWL-12C(53) </td>
        <td>TWL-5B(7)</td>
      </tr>
      <tr>
        <td>POA-504B(0)</td>
        <td>PSD-2071(92)</td>
        <td>PLA-1155(9)</td>
        <td>PAC-2410(0)</td>
        <td>BBL-351Combo(304)</td>
      </tr>
      <tr>
        <td>ITT-22(256) </td>
        <td>TPC-102C(52)</td>
        <td>PRH-685(52)</td>
        <td>CBI-101(288) </td>
        <td>CBI-102(276) </td>
      </tr>
      <tr>
        <td>CBI-103(263)</td>
        <td>CBI-104(284)</td>
        <td>CBI-202(285) </td>
        <td>CBI-205(286)</td>
        <td>CBI-207(283)</td>
      </tr>
      <tr>
        <td>NAP-B39(6) </td>
        <td>KBV-37B3(9)</td>
        <td>KGV-19P2(3)</td>
        <td>KGV-24P2(3)</td>
        <td>HKK-332(0)</td>
      </tr>
      <tr>
        <td>CBI-307(284) </td>
        <td>BCC-1101(0) </td>
        <td>RPT-14T(264)</td>
        <td>PPS-1416(262)</td>
        <td>PPS-1418(262)</td>
      </tr>
      <tr>
        <td>HKK-236(20)</td>
        <td>BBL-251(146)</td>
        <td> KVR-E704(133)</td>
        <td> KRV-514(0)</td>
        <td>KRV-2823(11)</td>
      </tr>
      <tr>
        <td>WH2-1169(100)</td>
        <td>PLO-6590(62) </td>
        <td>HKK-229(20) </td>
        <td>HKK-104(4) </td>
        <td>HKK-108(4)</td>
      </tr>
      <tr>
        <td>HALE-1470(9)</td>
        <td>KRV-724(0) </td>
        <td>KS-815(0) </td>
        <td> PEA-1260(0) </td>
        <td> KRV-1823(9)</td>
      </tr>
      <tr>
        <td>PEA-1009(64)</td>
        <td>AGC-8(44)</td>
        <td>FST-4163(56)</td>
        <td> PAS-2680(287) </td>
        <td>VIR-508(2)</td>
      </tr>
      <tr>
        <td>STR-1(15) </td>
        <td> MAS-2070(0)</td>
        <td>WH1-1218(73)</td>
        <td> KRO-Q301(108) </td>
        <td>HOI-A503(24)</td>
      </tr>
      <tr>
        <td> KBV-17G4(94)</td>
        <td>KRO-K302(14)</td>
        <td>MBY-H413(3)</td>
        <td> KGV-20T8(2) </td>
        <td>TPC-301C(168)</td>
      </tr>
      <tr>
        <td>WH1-1211(3) </td>
        <td>KRO-L201(75)</td>
        <td>HOL-116(0) </td>
        <td> KVR-F405(43) </td>
        <td>CVW-2004(41)</td>
      </tr>
      <tr>
        <td>PWS-957(36) </td>
        <td>KBR-208(0)</td>
        <td>RKR-103(0)</td>
        <td> NAP-A25(9) </td>
        <td>MAS-2003(108) </td>
      </tr>
      <tr>
        <td> RGT-117(2)</td>
        <td>KPL-55(18) </td>
        <td>MAS-3053(124)</td>
        <td> HALE-61-205K(61)</td>
        <td>HALE-2809R(0)</td>
      </tr>
      <tr>
        <td>HKK-820(8)</td>
        <td>WH2-661(0)</td>
        <td> PM-409(20) </td>
        <td> LOK-B201(153) </td>
        <td>MVA-3402(10) </td>
      </tr>
      <tr>
        <td> KUL-E113(0)</td>
        <td> KBV-31G4(0)</td>
        <td>KRO-G201(0)</td>
        <td>WH2-869(0)</td>
        <td>MAH-1219(0) </td>
      </tr>
      <tr>
        <td>MEL-H207(0)</td>
        <td>BVK-B-308(0) </td>
        <td></td>
        <td> </td>
        <td></td>
      </tr>
      </tbody>
    </table>
    
  </div>
  </div>
  <div class="ctm-table mt-3 units_mobile" style="overflow-x: auto;">
    <div class="ctm-title">
      <h2>Open Units Today:</h2>
    </div>
    <table style="width: 100%;">
      <tbody>
      <tr>
        <td>HKH-229(7) </td>
        <td>HKH-406(26)</td>
        <td>KRO-Q102(21)</td>
      </tr>
      <tr>
        <td>HKK-201(38)</td>
        <td>PKH-205(11)</td>
        <td>KBV-30G2(155)</td>
      </tr>
      <tr>
        <td>HKH-203(23)</td>
        <td>MAH-611(123)</td>
        <td> HKH-225(90)</td>
      </tr>
      <tr>
        <td>KGV-16P3(6)</td>
        <td>NAP-C18(2)</td>
        <td>HKH-204(13) </td>
      </tr>
      <tr>
        <td>HKK-1029(43)</td>
        <td>MAH-1211(90)</td>
        <td>HKH-529(189)</td>
      </tr>
      <tr>
        <td>KGV-24P7(55)</td>
        <td>HKK-513(2)</td>
        <td>KBV-15B3(168)</td>
      </tr>
      <tr>
        <td>HKH-504(31)</td>
        <td>HKK-343(2)</td>
        <td>HKK-439(20)</td>
      </tr>
      <tr>
        <td>MAH-419(133)</td>
        <td>KBV-28G2(3)</td>
        <td>HKK-242(0)</td>
      </tr>
      <tr>
        <td>KGV-19T1(140)</td>
        <td>NAP-B39(6) </td>
        <td>KBV-37B3(9)</td>
      </tr>
      <tr>
        <td>KGV-19P2(3)</td>
        <td>KGV-24P2(3)</td>
        <td>HKK-332(0)</td>
      </tr>
      <tr>
        <td>HKL-12A(5) </td>
        <td>HKL-12B(3)</td>
        <td> NAP-C43(17) </td>
      </tr>
      <tr>
        <td>TWL-12C(53) </td>
        <td>TWL-5B(7)</td>
        <td>POA-504B(0)</td>
      </tr>
      <tr>
        <td>PSD-2071(92)</td>
        <td>PLA-1155(9)</td>
        <td>PAC-2410(0)</td>
      </tr>
      <tr>
        <td>BBL-351Combo(304)</td>
        <td>ITT-22(256) </td>
        <td>TPC-102C(52)</td>
      </tr>
      <tr>
        <td>PRH-685(52)</td>
        <td>CBI-101(288) </td>
        <td>CBI-102(276) </td>
      </tr>
      <tr>
        <td>CBI-103(263)</td>
        <td>CBI-104(284)</td>
        <td>CBI-202(285) </td>
      </tr>
      <tr>
        <td>CBI-205(286)</td>
        <td>CBI-207(283)</td>
        <td>NAP-B39(6) </td>
      </tr>
      <tr>
        <td>KBV-37B3(9)</td>
        <td>KGV-19P2(3)</td>
        <td>KGV-24P2(3)</td>
      </tr>
      <tr>
        <td>HKK-332(0)</td>
        <td>CBI-307(284) </td>
        <td>BCC-1101(0) </td>
      </tr>
      <tr>
        <td>RPT-14T(264)</td>
        <td>PPS-1416(262)</td>
        <td>PPS-1418(262)</td>
      </tr>
      <tr>
        <td>HKK-236(20)</td>
        <td>BBL-251(146)</td>
        <td> KVR-E704(133)</td>
      </tr>
      <tr>
        <td> KRV-514(0)</td>
        <td>KRV-2823(11)</td>
        <td>WH2-1169(100)</td>
      </tr>
      <tr>
        <td>PLO-6590(62) </td>
        <td>HKK-229(20) </td>
        <td>HKK-104(4) </td>
      </tr>
      <tr>
        <td>HKK-108(4)</td>
        <td>HALE-1470(9)</td>
        <td>KRV-724(0) </td>
      </tr>
      <tr>
        <td>KS-815(0) </td>
        <td> PEA-1260(0) </td>
        <td> KRV-1823(9)</td>
        </tr>
        <tr>
          <td>PEA-1009(64)</td>
          <td>AGC-8(44)</td>
          <td>FST-4163(56)</td>
        </tr>
        <tr>
          <td> PAS-2680(287) </td>
          <td>VIR-508(2)</td>
          <td>STR-1(15) </td>
        </tr>
        <tr>
          <td> MAS-2070(0)</td>
          <td>WH1-1218(73)</td>
          <td> KRO-Q301(108) </td>
        </tr>
        <tr>
          <td>HOI-A503(24)</td>
          <td> KBV-17G4(94)</td>
          <td>KRO-K302(14)</td>
        </tr>
        <tr>
          <td>MBY-H413(3)</td>
          <td> KGV-20T8(2) </td>
          <td>TPC-301C(168)</td>
        </tr>
        <tr>
          <td>WH1-1211(3) </td>
          <td>KRO-L201(75)</td>
          <td>HOL-116(0) </td>
        </tr>
        <tr>
          <td> KVR-F405(43) </td>
          <td>CVW-2004(41)</td>
          <td>PWS-957(36) </td>
        </tr>
        <tr>
          <td>KBR-208(0)</td>
          <td>RKR-103(0)</td>
          <td> NAP-A25(9) </td>
        </tr>
        <tr>
          <td>MAS-2003(108) </td>
          <td> RGT-117(2)</td>
          <td>KPL-55(18) </td>
        </tr>
        <tr>
          <td>MAS-3053(124)</td>
          <td> HALE-61-205K(61)</td>
          <td>HALE-2809R(0)</td>
        </tr>
        <tr>
          <td>HKK-820(8)</td>
          <td>WH2-661(0)</td>
          <td> PM-409(20) </td>
        </tr>
        <tr>
          <td> LOK-B201(153) </td>
          <td>MVA-3402(10) </td>
          <td> KUL-E113(0)</td>
        </tr>
        <tr>
          <td> KBV-31G4(0)</td>
          <td>KRO-G201(0)</td>
          <td>WH2-869(0)</td>
        </tr>
        <tr>
        <td>MAH-1219(0) </td>
        <td>MEL-H207(0)</td>
        <td>BVK-B-308(0) </td>
      </tr>
      </tbody>
    </table>
    
  </div>
  <div class="main_table">
  <div class="row inout justify-content-evenly">
    <div class="col-1 flex flex-column align-items-center justify-content-center">
      <div class="ctm_content">
        <h3>HKH-344</h3>
        <p>Lahaina</p>
      </div>
    </div>
    <div class="col-5">
      <div class="ctm-table mt-5 in-out mobile" style="overflow-x: auto;">
        <div class="ctm-title">
          <h2>OUT</h2>
        </div>
        <table style="width: 100%;">
          <thead>
          <tr>
            <th>Nts</th>
            <th>A-In	</th>
            <th>C-In	</th>
            <th>C-Out	</th>
            <th>A-Out	</th>
            <th>Guests</th>
            <th>Keys</th>
            <th>$Bal</th>
          </tr>
          <tr>
            <td>7</td>
            <td></td>
            <td>Wed 04/03	</td>
            <td>Wed 04/10	</td>
            <td></td>
            <td>2/0	</td>
            <td>RESORT</td>
            <td>$-297.27
            </td>
          </tr>
          </thead>
        </table>
        <table class="desktop_only" style="width: 100%;">
          <tbody>
          <tr>
            <td>Guest</td>
            <td>April Musick () - HKH-344 Reserved</td>
          </tr>
          <tr>
            <td>Vacation # / Other # Contact :</td>
            <td>916-612-8727 / (916) 612-8727 </td>
          </tr>
          <tr>
            <td>Conf</td>
            <td></td>
          </tr>
          <tr>
            <td>Notes to Guest :	</td>
            <td>Guest Notes
            </td>

          </tr>
          <tr>
            <td>Notes from Guest :	</td>
            <td>No Comments
            </td>
          </tr>
          <tr>
            <td>Travel Occasion :	</td>
            <td>****   
            </td>
          </tr>
          <tr>
            <td>Notes to Ops :	</td>
            <td>LYNX: 77486 Sirvoy MM Pest Treatment 4/8

          </tr>
          <tr>
            <td>Housemen</td>
            <td></td>
          </tr>
          <tr>
            <td>Scheduling</td>
            <td>Last Out: 0 days ago . Next In: 0 days </td>
          </tr>
          </tbody>
        </table>
      </div> 
    </div>
    <div class="col-5">
      <div class="ctm-table mt-5 in-out" style="overflow-x: auto;">
        <div class="ctm-title">
          <h2>IN</h2>
        </div>
        <table style="width: 100%;">
          <thead>
          <tr>
            <th>Nts</th>
            <th>A-In	</th>
            <th>C-In	</th>
            <th>C-Out	</th>
            <th>A-Out	</th>
            <th>Guests</th>
            <th>Keys</th>
            <th>$Bal</th>
          </tr>
          </thead>
          <tbody>
            <tr>
              <td>7</td>
              <td></td>
              <td>Wed 04/03	</td>
              <td>Wed 04/10	</td>
              <td></td>
              <td>2/0	</td>
              <td>RESORT</td>
              <td>$-297.27
              </td>
            </tr>
          </tbody>
        </table>
        <table class="desktop_only" style="width: 100%;">
          <tbody>
          <tr>
            <td>Guest</td>
            <td>April Musick () - HKH-344 Reserved</td>
          </tr>
          <tr>
            <td>Vacation # / Other # Contact :</td>
            <td>916-612-8727 / (916) 612-8727 </td>
          </tr>
          <tr>
            <td>Conf</td>
            <td></td>
          </tr>
          <tr>
            <td>Notes to Guest :	</td>
            <td>Guest Notes
            </td>

          </tr>
          <tr>
            <td>Notes from Guest :	</td>
            <td>No Comments
            </td>
          </tr>
          <tr>
            <td>Travel Occasion :	</td>
            <td>****   
            </td>
          </tr>
          <tr>
            <td>Notes to Ops :	</td>
            <td>LYNX: 77486 Sirvoy MM Pest Treatment 4/8

          </tr>
          <tr>
            <td>Housemen</td>
            <td></td>
          </tr>
          <tr>
            <td>Scheduling</td>
            <td>Last Out: 0 days ago . Next In: 0 days </td>
          </tr>
          </tbody>
        </table>
      </div> 
    </div>
  </div>
  </div>
  <div class="ctm-table mt-5 in-out mobile_new" style="overflow-x: auto;">
    <div class="ctm-title">
      <h2>OUTs & INs</h2>
    </div>
    <div class="flex flex-column align-items-center justify-content-center">
      <div class="ctm_content">
        <h3>HKH-344</h3>
        <p>Lahaina</p>
      </div>
    </div>
    <table style="width: 100%;">
      <thead>
        <tr>
          <th></th>
          <th>OUT</th>
          <th>IN</th>
        </tr>
      </thead>
      <tbody>
      <tr>
        <td>Nts</td>
        <td><b>6</b></td>
        <td><b>5</b></td>
      </tr>
      <tr>
        <td>A-In</td>
        <td></td>
        <td></td>
      </tr>
      <tr>
        <td>C-In	</td>
        <td><b>Thu 04/04</b></td>
        <td><b>Wed 04/10</b></td>
      </tr>
      <tr>
        <td>C-Out	</td>
        <td><b>Wed 04/10</b></td>
        <td><b>Mon 04/15</b>	</td>
      </tr>
      <tr>
        <td>A-Out	</td>
        <td></td>
        <td></td>
      </tr>
      <tr>
        <td>Guests</td>
        <td><b>2/2	</b></td>
        <td><b>2/0</b>	</td>
      </tr>
      <tr>
        <td>Keys</td>
        <td><b>RESORT</b></td>
        <td><b>RESORT</b></td>
      </tr>
      <tr>
        <td>$Bal</td>
        <td><b>$2,840.07</b></td>
        <td><b>$-88.09</b></td>
      </tr>
      <tr>
        <td>Guest</td>
        <td>April Musick () - HKH-344 Reserved</td>
        <td>Harrison Baumann - Reserved</td>
      </tr>
      <tr>
        <td>Vacation # / Other # Contact :</td>
        <td>916-612-8727 / (916) 612-8727 </td>
        <td>707-484-4130 (707) 484-4130</td>
      </tr>
      <tr>
        <td>Conf</td>
        <td></td>
        <td></td>
      </tr>
      <tr>
        <td>Notes to Guest :	</td>
        <td>Guest Notes
        </td>
        <td>Guest Notes
        </td>
      </tr>
      <tr>
        <td>Notes from Guest :	</td>
        <td>No Comments
        </td>
        <td>Special</td>
      </tr>
      <tr>
        <td>Travel Occasion :	</td>
        <td>****   
        </td>
        <td>****   
        </td>
      </tr>
      <tr>
        <td>Notes to Ops :	</td>
        <td>LYNX: 77486 Sirvoy MM Pest Treatment 4/8
        </td>
        <td>LYNX: 44130 Sirvoy MM Service Fee: 270 Alfred: 707-953-5123
        </td>
      </tr>
      <tr>
        <td>Housemen</td>
        <td></td>
        <td>
          __ KINGS:1 <br>
          __ BATHROOMS:1
        </td>
      </tr>
      <tr>
        <td>Scheduling</td>
        <td>Last Out: 0 days ago . Next In: 0 days </td>
        <td>
          Last Out: 0 days ago. Next In: 27 days
        </td>
      </tr>
      </tbody>
    </table>
  </div> 
</div>
